var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.showReport)?_c('div',[_c('QualityReport',{attrs:{"score":_vm.score,"image":_vm.image},on:{"listenToChildEvent":_vm.handlePlayAgain}})],1):_vm._e(),(_vm.closeReport)?_c('div',[_c('Quality',{on:{"listenToChildEvent":_vm.handlQuality}})],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }